import graphqlRequest from "../curriculumRequest";
import GET_CURRICULUM from "./getCurriculumGraphql";

export async function getCurriculum(lessonPlanIds) {
  let inputs = {
    lessonPlanIds,
  };

  return await graphqlRequest(GET_CURRICULUM, inputs);
}
